<mat-form-field
        [appearance]="asFormsControl().outline ? 'outline' : 'legacy'"
        [floatLabel]="outlined ? 'always' : !asFormsControl().floatingLabelNever ? 'auto' : 'never'"
        class="app-input"
>
    <mat-label *ngIf="asFormsControl().outline && !asFormsControl().floatingLabelNever">{{ asFormsControl().placeholder }}</mat-label>

    <input
            matInput
            #input
            [placeholder]="asFormsControl().placeholder"
            [disabled]="asFormsControl().disabled"
            (focus)="onTouched && onTouched()"
			(change)="changeValue($event)"
			(keyup)="changeValue($event)"
            (keydown)="toUpperCase($event)"
            (paste)="changeValue($event)"
            [readonly]="asFormsControl().readonly"
    >
    <mat-hint *ngIf="(asFormsControl().errors.length <= 0) && hasHint" align="start">
        {{ asFormsControl().hint }}
    </mat-hint>
</mat-form-field>
<div *ngIf='asFormsControl().errors.length > 0' class="form-text text-danger">
    <span *ngFor="let error of asFormsControl().errors">{{error}}</span>
</div>
